import { customAxios } from '../../common/customAxios';
export const getWeeklyProductViews = (): Promise<number> => {
  return customAxios.get(`/key-value-checks/weekly-product-views`);
};
